module.exports = __webpack_public_path__ + "static/Isabel-Marant-bg-cbf9e3c32ac33ae10d5a2e294af76b6a.jpg";